"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenObject = void 0;
const real_type_of_1 = require("../real-type-of");
const flattenObject = (input, prefix = '', separator = '.', ignoreArrays = false) => {
    if ((0, real_type_of_1.isObject)(input) || (!ignoreArrays && (0, real_type_of_1.isArray)(input))) {
        return Object.entries(input).reduce((acc, [key, value]) => {
            const newKey = prefix ? `${prefix}${separator}${key}` : key;
            return {
                ...acc,
                ...(0, exports.flattenObject)(value, newKey, separator, ignoreArrays)
            };
        }, {});
    }
    return { [prefix]: input };
};
exports.flattenObject = flattenObject;
//# sourceMappingURL=flatten.js.map